import { Link } from "gatsby";
import React from "react";

const SubLevels = ({ sublevels, resourcesLink }) => {
    const subLinks = sublevels.map(({ url_slug, title }) => {
        if (!url_slug) {
            return (
                <div className="sectionLabelSub" key={title}>
                    {title}
                </div>
            );
        }
        return (
            <Link
                className="mobileSubLinks"
                key={url_slug}
                to={`${resourcesLink}${url_slug}/`}
                style={{ display: "block" }}
            >
                {title}
            </Link>
        );
    });
    return <>{subLinks}</>;
};

export default SubLevels;
